<template>
  <!-- --------------------------------------------------------- -->
  <!-- ---------------- Page Header ----------------------------- -->
  <!-- --------------------------------------------------------- -->

  <div class="mainPageDiv">

    <div class="pageHeader">
      Contracts
    </div>

    <span class="subHeaderFont">Create New Contract:</span>


    <div @click="handleCreateRecord()" class="material-icons forIconNewRecord text-success" data-tooltip="tooltip"
      title="Create a new Contract">
      add_card
    </div>

    <div class="radioheaderadjustment radioFirstLeftMargin">
      <input type="radio" @change="handleRadioChangeCntrcData()" id="activeContractsID" name="contractDataSetup"
        checked aria-label="Show Active Contract" />
      <label class="lableMargin  subHeaderFont" for="setup">Active</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin ">
      <input type="radio" @change="handleRadioChangeCntrcData()" id="allContractsID" name="contractDataSetup" aria-label="Show All Contracts"/>
      <label class="lableMargin  subHeaderFont" for="setup">All</label>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <ApplicationGrid :GridData="gridTime" 
                     RowsPerPageText="Contract Records"
                     SearchText="Search Contract Records:"
                     :EnablePaging="true" 
                     :EnableSearching="true" 
                     :EnableSorting="true"
                     :HeaderArrays="headerArrays" 
                     :LeftRightSlots="leftRightSlots" 
                     :EnableSettings="true"
                     :RowsPerPageArray="rowsPerPageArray" 
                     :EnableRecordsInfoDisplay="true">

      <!-- ------------------------------------------------------------------------ -->
      <!-- -------------- RIGHT Action (rightHeader11/rightData11) ---------------- -->
      <!-- ------------------------------------------------------------------------ -->

      <template v-slot:rightHeader11>
        <span class="xxxactionsHeader">Edit</span>
      </template>

      <template v-slot:rightData11="slotArgs">

        <span @click="handleEditRecord(slotArgs)" class="material-icons text-primary" data-tooltip="tooltip"
          title="Edit Record">
          edit
        </span>

      </template>

      <!-- ------------------------------------------------------------------------------- -->
      <!-- -------------- SLOT END ------------------------------------------------------- -->
      <!-- ------------------------------------------------------------------------------- -->

    </ApplicationGrid>

  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL Update-Create start ------------------------ -->
  <!-- ------------------------------------------------------------------------------ -->

  <div id="xmodal-main-ID" class="xmodal-container-main">

    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary headerMainContainer">
        <div style="display: inline-block;">&nbsp;</div>
        <div style="color: white; display: inline-block">{{ modalTitle }}</div>
        <div class="cancelModalX" @click="CloseModalUpdateCreate" style="margin-right: 10px; color: white; display: inline-block; text-align: right; align-items: end;">X</div>
      </div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">
        <!-- ------- Record Id -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Database Record ID">
          Record Id</div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="firstNameTxtBx" v-model="contractId" type="text" disabled aria-label="Record ID" />
        </div>
        <!-- ------- Contract Number -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Contract Number">
          Contract Number<span v-if="contractNumberUndefined || contractNumberNotUnique"
            class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input style="width: 400px;" id="lastNameTxtBx" v-model="contractNumber" type="text" aria-label="Contract Number"/>
        </div>

        <!-- ------- Arming Authority list -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Arming Authority Acronym">
          Arming Authority<span v-if="armingAuthorityAcronymUndefined"
            class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <select id="armingAuthorityDdlId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedArmingAuthorityId" style="margin: 0px" aria-label="Select the Arming Authority">
            <option v-for="item in armingAuthorityList" :value="item.armingAuthorityId" :key="item.armingAuthorityId">
              {{ item.armingAuthorityAcronym }}
            </option>
          </select>

        </div>

        <!-- ------- Agency list -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Agency">
          Agency<span v-if="armingAuthorityAcronymUndefined"
            class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <select id="armingAuthorityDdlId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedAgencyId" style="margin: 0px" aria-label="Select the Agency">
            <option v-for="item in agencyList" :value="item.agencyId" :key="item.agencyId">
              {{ item.agencyName }}
            </option>
          </select>

        </div>

        <!-- ------- Company Name -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Name">
          Company Name<span v-if="companyNameUndefined" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <select id="CompanylId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedCompanyID" style="margin: 0px" aria-label="Select the Company">
            <option v-for="item in companyList" :value="item.companyId" :key="item.companyId">
              {{ item.companyName }}
            </option>
          </select>
        </div>

        <!-- ------- Camp Name -->
        <label class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip">Camp
          Name<span v-if="campNameUndefined" class="xmodal-required-asterisk text-danger">*</span></label>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <select id="CampLocationlId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedCampLocationId" style="margin: 0px">
            <option v-for="item in CampLocationList" :value="item.campLocationId" :key="item.campLocationId">
              {{ item.campName }}
            </option>
          </select>

        </div>
        <!-- ------- Country -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Country">
          Country<span v-if="countryNameUndefined" class="xmodal-required-asterisk  text-danger">*</span></div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">


          <select id="CountryId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedCountryID" style="margin: 0px">
            <option v-for="item in countryList" :value="item.countryId" :key="item.countryId">
              {{ item.countryName }}
            </option>
          </select>


        </div>
        <!-- ------- Contract Summary -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Contract Summary">
          Contract Summary
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <!-- <input id="roleTxtBx" v-model="summary" type="text" /> -->
          <textarea id="summaryTextID" class="xmodal-textarea-padding" rows="2" cols="60" v-model="summary" aria-label="Contract Summary"></textarea>
        </div>
        <!-- ------- Start Date -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Contract Start Date">Start Date<span v-if="(contractStartDateUndefined || startGreaterThanEndDate)"
            class="xmodal-required-asterisk text-danger">*</span></div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <!-- <input id="roleTxtBx" v-model="contractStartDate" type="text" /> -->
          <input type="date" class="xmodal-date-padding" v-model="contractStartDate" aria-label="Start Date" />
        </div>
        <!-- ------- End Date -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Contract End Date">
          End Date<span v-if="(contractEndDateUndefined || startGreaterThanEndDate)"
            class="xmodal-required-asterisk text-danger">*</span></div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <!-- <input id="roleTxtBx" v-model="contractEndDate" type="text" /> -->
          <input type="date" class="xmodal-date-padding" v-model="contractEndDate" aria-label="End Date" />

        </div>
        <!-- ------- Critical Date -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Critical Date">
          Critical Date
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input type="date" class="xmodal-date-padding" v-model="missionCritical" aria-label="Critical Date" />
        </div>
        <!-- ------- Update Date -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Database Update Date">Update Date</div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="roleTxtBx" v-model="updateDate" type="text" disabled aria-label="Update Date"/>
        </div>
      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <hr v-if="validationErrorsFound" class="xmodal-hr-bottom" />
      <div v-if="validationErrorsFound" class="text-danger xmodal-validation-outer-div">Required fields indicated by asterisk(s).
        Make selections for the following:
        <div class="xmodal-inner-div">
          <ul class="xmodal-li-validation">
            <li v-if="contractNumberUndefined"> Contract Number </li>
            <li v-if="contractNumberNotUnique"> Contract Number already exists </li>
            <li v-if="agencyUndefined"> Agency </li>
            <li v-if="armingAuthorityAcronymUndefined"> Arming Authority </li>
            <li v-if="companyNameUndefined"> Company Name </li>
            <li v-if="campNameUndefined"> Camp Name </li>
            <li v-if="countryNameUndefined"> Country </li>
            <li v-if="contractStartDateUndefined"> Start Date </li>
            <li v-if="contractEndDateUndefined"> End Date </li>
            <li v-if="startGreaterThanEndDate"> Start Date must preceed End Date </li>
          </ul>
        </div>
      </div>

      <ContractDocuments ref="ContractDocumentListComponent"></ContractDocuments>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <!-- cancelButton -->

      <div class="xmodal-footer">
        <button type="button" @click="CloseModalUpdateCreate" class="btn-danger">
          Cancel
        </button>
        <button id="xmodal-submit-btn-id" type="button" @click="handleEditClickSubmitBtn" class="btn-primary">
          Submit
        </button>
      </div>
    </div>

  </div>
</template>
  
<script>
import axios from "axios";
import { store } from "../../../store/store.js";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue";
import ContractDocuments from "@/components/ContractHelper/ContractDocuments.vue"; 

export default {
  data() {
    return {
      store,

      gridTime: { grid: null, time: null },
      SelectedRecord: null,

      //  'active' or 'all'
      contractDataType: 'active',

      uniqueContractNumberList: null,

      rowsPerPageArray: [10, 25, 50, 100, 250],

      headerArrays: [
        { defaultShow: false, rawName: 'contractId', displayName: 'ID', hoverText: 'Contract ID' },
        { defaultShow: true, rawName: 'contractNumber', displayName: 'Contract', hoverText: 'Contract Number' },
        { defaultShow: false, rawName: 'contractActive', displayName: 'Active', hoverText: 'Computed Field: Contract is Active' },
        { defaultShow: true, rawName: 'armingAuthorityAcronym', displayName: 'Arming', hoverText: 'Arming Authority Acronym' },
        { defaultShow: false, rawName: 'armingAuthorityName', displayName: 'Arming Name', hoverText: 'Arming Authority Name' },
        { defaultShow: false, rawName: 'armingAuthorityId', displayName: 'Arming ID', hoverText: 'Arming Authority ID' },
        { defaultShow: false, rawName: 'agencyAcronym', displayName: 'Agency Acronym', hoverText: 'Agency Acronym' },
        { defaultShow: false, rawName: 'agencyName', displayName: 'Agency Name', hoverText: 'Agency Name' },
        { defaultShow: false, rawName: 'agencyId', displayName: 'Agency Id', hoverText: 'Agency Id' },
        { defaultShow: true, rawName: 'companyName', displayName: 'Company', hoverText: 'Company Name' },
        { defaultShow: false, rawName: 'companyCountry', displayName: 'Company Country', hoverText: 'Company Country' },
        { defaultShow: false, rawName: 'companyState', displayName: 'Company State', hoverText: 'Company State' },
        { defaultShow: false, rawName: 'companyCity', displayName: 'Company City', hoverText: 'Company City' },
        { defaultShow: false, rawName: 'companyId', displayName: 'Company ID', hoverText: 'Company ID' },
        { defaultShow: true, rawName: 'campName', displayName: 'Camp', hoverText: 'Camp Name' },
        { defaultShow: false, rawName: 'campCountry', displayName: 'Camp Country', hoverText: 'Camp Country' },
        { defaultShow: false, rawName: 'campLocationId', displayName: 'Camp Loc ID', hoverText: 'Camp Location ID' },
        { defaultShow: true, rawName: 'summary', displayName: 'Summary', hoverText: 'Summary' },
        { defaultShow: false, rawName: 'countryName', displayName: 'Contract Country', hoverText: 'Contract Country Name' },
        { defaultShow: false, rawName: 'countryId', displayName: 'Contract Country ID', hoverText: 'Contract Country ID' },
        { defaultShow: true, rawName: 'contractStartDate', displayName: 'Start', hoverText: 'Contract Start Date' },
        { defaultShow: true, rawName: 'contractEndDate', displayName: 'End', hoverText: 'Contract End Date' },
        { defaultShow: true, rawName: 'missionCritical', displayName: 'Critical', hoverText: 'Mission Critical Date' },
        { defaultShow: true, rawName: 'updateDate', displayName: 'Update', hoverText: 'Last Update Date' },
        { defaultShow: false, rawName: 'createDate', displayName: 'Create', hoverText: 'Create Date' },
        { defaultShow: false, rawName: 'createUser', displayName: 'Create By', hoverText: 'User who created the record' },
        { defaultShow: false, rawName: 'updateUser', displayName: 'Update By', hoverText: 'User who last updated the record' }
      ],

      //leftHeader0,   ..., leftHeader9
      //rightHeader10, ..., rightHeader19
      leftRightSlots: [
        { slot: 'rightHeader11', enableSorting: true, field: '__not_specified__' },
      ],

      modalTitle: null,
      createSelected: false,

      //----- contract records START
      contractId: null,
      contractNumber: null,
      countryName: null,
      summary: null,
      contractStartDate: null,
      contractEndDate: null,
      missionCritical: null,
      updateDate: null,
      //----- contract records END

      // ------------ CampLocation
      CampLocationList: null,
      selectedCampLocationId: null,
      defaultCampLocation: {
        campLocationId: -1,
        campName: "Please Select a Value"
      },

      campName: null,

      // ------------ ArmingAuthority
      armingAuthorityList: null,
      selectedArmingAuthorityId: null,
      defaultArmingAuthority: {
        armingAuthorityId: -1,
        armingAuthorityName: "Used for the default dropdown element.",
        armingAuthorityAcronym: "Please Select a Value"
      },

      //------------- Agency
      agencyList: null,
      selectedAgencyId: null,
      defaultAgency: { agencyId: -1, agencyName: 'Please Select a Value' },

      // ------------ Company
      companyList: null,
      selectedCompanyID: null,
      defaultCompany: { companyId: -1, companyName: 'Please Select a Value' },

      // ------------ Country
      countryList: null,
      selectedCountryID: null,
      defaultCountry: { countryId: -1, countryName: 'Please Select a Value' },

      //----- validation checks START

      submitDisabled: true,
      validationErrorsFound: false,

      contractNumberUndefined: false,
      armingAuthorityAcronymUndefined: false,
      agencyUndefined: false,
      companyNameUndefined: false,
      campNameUndefined: false,
      countryNameUndefined: false,
      contractStartDateUndefined: false,
      contractEndDateUndefined: false,
      startGreaterThanEndDate: false,
      contractNumberNotUnique: false,

      //----- validation checks END
    };
  },
  created() {

    this.getAllContracts();
    this.getAllArmingAuthority();
    this.getAllCompany();
    this.getAllCampLocation();
    this.getAllCountry();
    this.getAllUniqueContractNumbers();
    this.getAgencies();
  },
  components: { ApplicationGrid, ContractDocuments },

  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null
        ? store.authenticatedUser.userProfileId
        : store.tempUserProfileId;
    },
  },

  methods: {

    //---------------------- General Suport ----------------------------------

    //Used to format dates passed to the HTML date control.
    formatDateFnc(value) {
      let monthPart = value.substring(0, 2);
      let dayPart = value.substring(3, 5);
      let yearPart = value.substring(6, value.length);
      return yearPart + '-' + monthPart + '-' + dayPart;
    },

    handleRadioChangeCntrcData() {
      let activeDataRadioBtn = document.querySelector("#activeContractsID");
      let allDataRadioBtn = document.querySelector("#allContractsID");

      // console.log('activeDataRadioBtn.checked = ', activeDataRadioBtn.checked);
      // console.log('allDataRadioBtn.checked = ', allDataRadioBtn.checked);

      //contractDataType os a query string paramter in the call to
      //the web service which returns the contract records.
      if (activeDataRadioBtn.checked) {
        this.$data.contractDataType = 'active';
      } else if (allDataRadioBtn.checked) {
        this.$data.contractDataType = 'all';
      }

      // console.log('this.$data.contractDataType = ', this.$data.contractDataType);

      //Refresh the grid data based on the radiobutton selection.
      this.getAllContracts();

    },

    // --------------------------------------------------------------------------
    // ---------------- getAgencies ---------------------------------------------
    // --------------------------------------------------------------------------

    getAgencies() {

      axios
        .get(store.webAPIUrl + "Agency/SelAgencies/Active")
        .then((response) => response.data)
        .then((data) => {
          this.$data.agencyList = data;
          this.$data.selectedAgencyId = this.$data.defaultAgency.agencyId;
          //Add the default item to the top of the list.
          this.$data.agencyList.unshift(this.$data.defaultAgency);

        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllContracts -----------------------------------------
    // --------------------------------------------------------------------------

    getAllContracts() {
      // console.log("ContractRecords.vue getAllContracts()");
      // console.log('this.$data.contractDataType = ', this.$data.contractDataType);
      axios
        .get(store.webAPIUrl + "Contract/SelAllContracts/" + this.$data.contractDataType)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          // console.log("ContractRecords.vue getAllContracts()");
          // console.log("data = ", data);
          // console.log("data.length = ", data.length);
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllContracts -----------------------------------------
    // --------------------------------------------------------------------------

    getAllUniqueContractNumbers() {
      // console.log("ContractRecords.vue getAllContracts()");
      axios
        .get(store.webAPIUrl + "Contract/selAllUniqueContractNumbers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.uniqueContractNumberList = data;
          // console.log("ContractRecords.vue getAllUniqueContractNumbers()");
          // console.log("data = ", data);
          // console.log("data.length = ", data.length);
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllArmingAuthority -----------------------------------
    // --------------------------------------------------------------------------

    getAllArmingAuthority() {
      // console.log("ContractRecords.vue getAllArmingAuthority()");
      axios
        .get(store.webAPIUrl + "ArmingAuthority/SelAllArmingAuthority")
        .then((response) => response.data)
        .then((data) => {
          this.$data.armingAuthorityList = data;

          //Add the default item to the top of the list.
          this.$data.armingAuthorityList.unshift(this.$data.defaultArmingAuthority);
          //Make the selection for the dropdown list.
          this.$data.selectedArmingAuthorityId = this.$data.defaultArmingAuthority.armingAuthorityId;

          // console.log('getAllArmingAuthority(): this.$data.selectedArmingAuthorityId = ', this.$data.selectedArmingAuthorityId);

        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllCompany -------------------------------------------
    // --------------------------------------------------------------------------

    getAllCompany() {
      // console.log("ContractRecords.vue getAllCompany()");
      axios
        .get(store.webAPIUrl + "Company/SelAllCompany")
        .then((response) => response.data)
        .then((data) => {
          this.$data.companyList = data;

          //Add the default item to the top of the list.
          this.$data.companyList.unshift(this.$data.defaultCompany);
          //Make the selection for the dropdown list.
          this.$data.selectedCompanyID = this.$data.defaultCompany.companyId;
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllCampLocation --------------------------------------
    // --------------------------------------------------------------------------

    getAllCampLocation() {
      // console.log("ContractRecords.vue getAllCampLocation()");
      axios
        .get(store.webAPIUrl + "CampLocation/SelAllCampLocation")
        .then((response) => response.data)
        .then((data) => {
          this.$data.CampLocationList = data;

          //Add the default item to the top of the list.
          this.$data.CampLocationList.unshift(this.$data.defaultCampLocation);
          //Make the selection for the dropdown list.
          this.$data.selectedCampLocationId = this.$data.defaultCampLocation.campLocationId;

        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllCountry --------------------------------------
    // --------------------------------------------------------------------------

    getAllCountry() {
      // console.log("ContractRecords.vue getAllCampLocation()");
      axios
        .get(store.webAPIUrl + "Country/SelAllCountry")
        .then((response) => response.data)
        .then((data) => {
          this.$data.countryList = data;

          //Add the default item to the top of the list.
          this.$data.countryList.unshift(this.$data.defaultCountry);
          //Make the selection for the dropdown list.
          this.$data.selectedCountryID = this.$data.defaultCountry.countryId;

        });
    },

    /* -------------------------------------------------------------- */
    /* ------------------- start MODAL script ----------------------- */
    /* -------------------------------------------------------------- */

    // -----------------------------
    // ---------------- Modal Create
    // -----------------------------

    //This is called in response to clicking the create div.The dialog
    //modal is opened due to properties set in the edit div. 
    handleCreateRecord() {
      // console.log('-->> handleCreateRecord()');
      this.$data.createSelected = true;
      this.clearValidationFields();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      this.$data.modalTitle = 'Create Contract Record';

      this.$data.contractId = null;
      this.$data.contractNumber = null;
      this.$data.campName = null;
      this.$data.countryName = null;
      this.$data.summary = null;
      this.$data.contractStartDate = null;
      this.$data.contractEndDate = null;
      this.$data.missionCritical = null;
      this.$data.updateDate = null;

      //This sets the selected values in the dropdown lists.
      this.$data.selectedArmingAuthorityId = this.$data.defaultArmingAuthority.armingAuthorityId;
      this.$data.selectedAgencyId = this.$data.defaultAgency.agencyId;
      this.$data.selectedCompanyID = this.$data.defaultCompany.companyId;
      this.$data.selectedCampLocationId = this.$data.defaultCampLocation.campLocationId;
      this.$data.selectedCountryID = this.$data.defaultCountry.countryId;

    },

    databaseCreateContract() {

      console.log('databaseCreateContract(): this.UserProfileId = ', this.UserProfileId);

      axios
        .post(store.webAPIUrl + "Contract/CreateContract/" +
          this.UserProfileId + '/' +
          this.$data.contractNumber + "/" +
          this.$data.selectedArmingAuthorityId + "/" +
          this.$data.selectedCompanyID + "/" +
          this.$data.selectedCampLocationId + "/" +
          this.$data.selectedCountryID + "/" +
          this.$data.selectedAgencyId + "/" +
          this.$data.summary + "/" +
          encodeURIComponent(this.$data.contractStartDate) + "/" +
          encodeURIComponent(this.$data.contractEndDate) + "/" +
          encodeURIComponent(this.$data.missionCritical)
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getAllContracts();
        });
    },

    // ------------------------------------
    // ---------------- Modal Update/Create
    // ------------------------------------

    //This method is called when clicking on the submit button
    //in the update modal.
    handleEditClickSubmitBtn() {

      this.validateFields();

      if (this.$data.validationErrorsFound == false) {

        let modalWindow = document.querySelector("#xmodal-main-ID");
        modalWindow.style.display = "none";

        if (this.$data.createSelected == true) {
          this.databaseCreateContract();
        } else {
          this.databaseUpdateContract();
        }
      }

    },


    validateContractNumbers() {
      let newNumberIsUnique = true;

      if (this.$data.contractNumber) {

        for (let i = 0; i < this.$data.uniqueContractNumberList.length; i++) {

          let numberVal = this.$data.uniqueContractNumberList[i].contractNumber;
          let idVal = this.$data.uniqueContractNumberList[i].contractId;

          // console.log('numberVal = ', numberVal);

          if ((numberVal == this.$data.contractNumber) && (idVal != this.$data.contractId)) {
            newNumberIsUnique = false;
            break;
          }
        }

      }

      return newNumberIsUnique;

    },

    validateFields() {

      this.clearValidationFields();

      if (!this.$data.contractNumber) {
        this.$data.contractNumberUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.validateContractNumbers() == false) {
        this.$data.contractNumberNotUnique = true;
        this.$data.validationErrorsFound = true;
      }

      if (!this.$data.contractEndDate) {
        this.$data.contractEndDateUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.selectedArmingAuthorityId == this.$data.defaultArmingAuthority.armingAuthorityId) {
        this.$data.armingAuthorityAcronymUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.selectedAgencyId == this.$data.defaultAgency.agencyId) {
        this.$data.agencyUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.selectedCompanyID == this.$data.defaultCompany.companyId) {
        this.$data.companyNameUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.selectedCampLocationId == this.$data.defaultCampLocation.campLocationId) {
        this.$data.campNameUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.selectedCountryID == this.$data.defaultCountry.countryId) {
        this.$data.countryNameUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (!this.$data.contractStartDate) {
        this.$data.contractStartDateUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (!this.$data.contractEndDate) {
        this.$data.contractEndDateUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.contractEndDate && this.$data.contractStartDate) {
        let d1 = Date.parse(this.$data.contractStartDate);
        let d2 = Date.parse(this.$data.contractEndDate);

        if (d1 > d2) {
          this.$data.startGreaterThanEndDate = true;
          this.$data.validationErrorsFound = true;
        }
      }

    },

    clearValidationFields() {
      this.$data.contractNumberUndefined = false;
      this.$data.contractNumberNotUnique = false;
      this.$data.armingAuthorityAcronymUndefined = false;
      this.$data.companyNameUndefined = false;
      this.$data.campNameUndefined = false;
      this.$data.countryNameUndefined = false;
      this.$data.contractStartDateUndefined = false;
      this.$data.contractEndDateUndefined = false;
      this.$data.startGreaterThanEndDate = false;

      this.$data.validationErrorsFound = false;
    },

    // ------------------------------------
    // ---------------- Update
    // ------------------------------------

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleEditRecord(args) {
      this.$data.modalTitle = 'Edit Contract Record';
      this.$data.createSelected = false;
      this.clearValidationFields();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      this.$data.contractId = args.itemArg["contractId"];
      this.$data.contractNumber = args.itemArg["contractNumber"];
      this.$data.countryName = args.itemArg["countryName"];
      this.$data.summary = args.itemArg["summary"];

      this.$data.contractStartDate = args.itemArg["contractStartDate"];
      if (this.$data.contractStartDate) {
        this.$data.contractStartDate = this.formatDateFnc(this.$data.contractStartDate);
      }

      this.$data.contractEndDate = args.itemArg["contractEndDate"];
      if (this.$data.contractEndDate) {
        this.$data.contractEndDate = this.formatDateFnc(this.$data.contractEndDate);
      }

      this.$data.missionCritical = args.itemArg["missionCritical"];
      if (this.$data.missionCritical) {
        this.$data.missionCritical = this.formatDateFnc(this.$data.missionCritical);
      }

      this.$data.updateDate = args.itemArg["updateDate"];

      //Set the selected arming authority.
      this.$data.selectedArmingAuthorityId = args.itemArg["armingAuthorityId"];

      //Set the selected arming authority.
      this.$data.selectedAgencyId = args.itemArg["agencyId"];

      //Set the selected company.
      this.$data.selectedCompanyID = args.itemArg["companyId"];

      //Set the selected Camp Location.
      this.$data.selectedCampLocationId = args.itemArg["campLocationId"];

      //Set the selected Country Location.
      this.$data.selectedCountryID = args.itemArg["countryId"];

      // console.log('handleEditRecord(args): this.$data.selectedCampLocationId = ', this.$data.selectedCampLocationId);
      // console.log('handleEditRecord(args): args.itemArg["campLocationId"] = ', args.itemArg["campLocationId"]);

      //remove lucas
      console.log("opening contract modal");
      this.$refs.ContractDocumentListComponent.LoadData(this.$data.contractId); 
    },

    databaseUpdateContract() {

      //Using a flag value such as the following avoids issues with
      //passing blank values in a query string.
      if (this.$data.summary == null) {
        this.$data.summary = "__null__";
      } else if (this.$data.summary.trim().length == 0) {
        this.$data.summary = "__null__";
      }

      axios
        .post(store.webAPIUrl + "Contract/UpdateContract/" +
          this.UserProfileId + "/" +
          this.$data.contractId + "/" +
          this.$data.contractNumber + "/" +
          this.$data.selectedArmingAuthorityId + "/" +
          this.$data.selectedCompanyID + "/" +
          this.$data.selectedCampLocationId + "/" +
          this.$data.selectedCountryID + "/" +
          this.$data.selectedAgencyId + "/" +
          this.$data.summary + "/" +
          encodeURIComponent(this.$data.contractStartDate) + "/" +
          encodeURIComponent(this.$data.contractEndDate) + "/" +
          encodeURIComponent(this.$data.missionCritical)
        )
        .then((response) => response.data)
        .then(() => {
          this.getAllContracts();
        });
    },

    CloseModalUpdateCreate() {
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
    },

    /* -------------------------------------------------------------- */
    /* ------------------- end MODAL script ------------------------- */
    /* -------------------------------------------------------------- */

  },
};
</script>
  
<style scoped>
/* ----------------- page ------------------------ */

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

/* --------------- page header ----------- */

.subHeaderFont {
  font-size: 18px;
}

.pageHeader {
  font-size: 24px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.lableMargin {
  margin-left: 5px;
}

/* ----------------- data type radio buttons ------------------------ */

.lableMargin {
  margin-left: 5px;
}

/* --------------- actions ----------- */

.actionsHeader {
  color: black;
  font-family: "Handlee";
  font-size: 16px;
  padding: 0px;
  margin: 0px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

.cancelButton {
  background: #6d757c;
  color: white;
  border-radius: 6px;
  margin-left: 10px;
  cursor: pointer;
}

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.headerMainContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 10% 80% 10%;
}

.cancelModalX {
  cursor: pointer;
}

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 10px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */

  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 25% 75%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 95%;
  height: 90%;

  max-height: 780px;
  max-width: 950px;

  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header footer ---------- */

.xmodal-footer {
  text-align: center;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- validation ---------- */

.xmodal-outer-div {
  margin: 5px;
  display: grid;
  grid-template-columns:80%;
  align-items: center;
  justify-content: center;
}
.xmodal-inner-div {
  margin: 0 auto;
}

.xmodal-li-validation {
  text-align: left;
  margin-top: 15px;
  color: black;
  width: 400px;
}

.xmodal-required-asterisk {
  margin-left: 2px;
  font-size: x-large;
}

/* ---------- content elements ---------- */

.xmodal-textbox-padding {
  padding: 5px;
}

.xmodal-date-padding {
  padding: 3px;
}

.xmodal-textarea-padding {
  padding: 8px;
}

.xmodal-dropdownlist-padding {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
}

.xmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: 400;
}

.xmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */</style>
  